<template>
  <div id="a-loader">
    <div class="loader-logo">
      <div class="loader-circles">
        <div class="circle c1">
          <div class="half"></div>
          <div class="half"></div>
          <div class="half"></div>
        </div>
        <div class="circle c2">
          <div class="half"></div>
          <div class="half"></div>
          <div class="half"></div>
        </div>
        <div class="circle c3">
          <div class="half"></div>
          <div class="half"></div>
          <div class="half"></div>
        </div>
      </div>
      <div class="loader-wordmark"></div>
    </div>
  </div>
</template>

<script>
import Loader from './loader';

let loader;

export default {
  mounted() {
    loader = new Loader();
    loader.init();
  },
};
</script>
